import { z } from "zod";

export const PolymarketCredentialsResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
});
export type PolymarketCredentialsResponse = z.infer<typeof PolymarketCredentialsResponseSchema>;

export const PolymarketCredentialsCheckResponseSchema = z.object({
  exists: z.boolean(),
});
export type PolymarketCredentialsCheckResponse = z.infer<typeof PolymarketCredentialsCheckResponseSchema>;

export const PolymarketOrderResponseSchema = z
  .object({
    orderID: z.string().optional(),
    status: z.string().optional(),
  })
  .loose();

export type PolymarketOrderResponse = z.infer<typeof PolymarketOrderResponseSchema>;

export const PolymarketBalanceResponseSchema = z.object({
  balance: z.number(),
  allowance: z.number(),
});
export type PolymarketBalanceResponse = z.infer<typeof PolymarketBalanceResponseSchema>;

export const PolymarketPositionResponseSchema = z.object({
  proxyWallet: z.string(),
  asset: z.string(),
  conditionId: z.string(),
  size: z.number(),
  avgPrice: z.number(),
  initialValue: z.number(),
  currentValue: z.number(),
  cashPnl: z.number(),
  percentPnl: z.number(),
  totalBought: z.number(),
  realizedPnl: z.number(),
  percentRealizedPnl: z.number(),
  curPrice: z.number(),
  redeemable: z.boolean(),
  mergeable: z.boolean(),
  title: z.string(),
  slug: z.string(),
  icon: z.string(),
  eventSlug: z.string(),
  eventId: z.string().optional(),
  outcome: z.string(),
  outcomeIndex: z.number(),
  oppositeOutcome: z.string(),
  oppositeAsset: z.string(),
  endDate: z.string(),
  negativeRisk: z.boolean(),
});

export type PolymarketPosition = z.infer<typeof PolymarketPositionResponseSchema>;

export const PolymarketPositionsResponseSchema = z.array(PolymarketPositionResponseSchema);
export type PolymarketPositionsResponse = z.infer<typeof PolymarketPositionsResponseSchema>;

export const PolymarketGeoblockResponseSchema = z.object({
  blocked: z.boolean(),
  ip: z.string().optional(),
  country: z.string().optional(),
  region: z.string().optional(),
});
export type PolymarketGeoblockResponse = z.infer<typeof PolymarketGeoblockResponseSchema>;
